import * as React from 'react';

import type { IconProps } from '../../types';

/**
 * Pulmonologist icon
 *
 * @category Medical
 */
const Pulmonologist = React.forwardRef<SVGSVGElement, IconProps>(
  ({ 'data-testid': testId, size = 20, className, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        data-testid={testId}
        width={size}
        height={size}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        role="img"
        aria-hidden="true"
        {...props}
      >
        <path
          fill="currentColor"
          d="M15.99 3.393c.447 0 .588.999.54 2.373.06 2.209-.067 4.416.903 5.385.458.54.813-.122.872-1.003.023-1.28.822-1.75 1.926-1.61 5.705.729 8.354 4.553 8.634 10.35.128 2.647.376 4.733-.47 6.789-1.68 4.182-8.869 3.817-9.902-.764-.447-2.63-.094-5.591-.2-8.998-.024-1.55.329-2.76-.729-3.747-.21-.211-.81-.258-.927.176-.282.94.188 4.206-.517 4.511-1.457.317-.313-4.808-1.111-5.219-1.293.611-1.497 2.165-1.403 3.739-.106 3.36.258 6.86-.2 9.55-1.033 4.581-8.234 4.945-9.902.764-.846-2.056-.34-4.617-.47-6.79-.345-5.808 3.125-9.785 8.634-10.349 1.116-.14 1.903.317 1.926 1.61.07.916.688 1.327 1.146.81.893-1.008.593-3.054.628-5.192-.047-1.363.094-2.361.54-2.373h.083zm-3.735 7.377c-.247-.751-.91-1.045-1.627-.916-3.054.717-5.797 3.16-6.42 5.873-.375 1.598-.005 3.63-.04 5.286-.09 4.17.143 4.73 2.598 6.139 3.365 1.175 5.09-.265 5.571-2.239.482-1.973.213-6.265.213-7.44 0-1.174.462-4.716-.935-3.412-.564.446-.97.97-1.733 2.424-.762 1.454-.207 2.91-1.045 2.72-.839-.19-.112-2.672.47-3.478.853-1.182 1.656-1.797.575-2.208-.61-.258-2.15-.857-1.75-1.621.164-.294.576-.34.998-.07 1.116.775 4.476 1.691 3.207-.858l-.058-.188zm9.542 3.775c1.069.435 2.357-.979 3.098-.368.234.376-.177.787-.588.893-1.116.235-1.327.552-.81 1.656.375.987.54 2.09.258 3.277-.482 1.574-1.222 1.104-1.08-.352.234-1.927-.53-3.477-1.904-4.617-.34-.223-1.38-.478-1.38.036 0 2.424-.187 3.13.298 8.463s6.512 4.985 7.755 1.842c.399-1.01.503-3.135.526-5.038-.058-1.856-.127-3.364-.526-5.162-.623-2.725-3.618-4.973-6.673-5.678-1.55-.422-1.726 1.896-1.221 3.082.307 1.481 1.412 1.667 2.247 1.966"
        />
      </svg>
    );
  }
);

Pulmonologist.displayName = 'Pulmonologist';

export { Pulmonologist };
